/**
 * @owner @Appboy/whats-app
 * WhatsApp Media Type Schema
 *
 * Shared schema for media types used across WhatsApp messages.
 * Values match the backend SharedConstants::COMMUNICATION[:WHATS_APP][:MEDIA] keys.
 */

import { z } from "zod";
import { common } from "@schemas/common";

export const whatsAppMediaTypeSchema = z
  .enum([
    "i", // image
    "v", // video
    "d", // document
    "a", // audio
  ])
  .optional()
  .nullable();

/**
 * Include this in other whatsapp message types that support media headers
 */
export const whatsAppMediaHeaderSchema = z.object({
  // undefined: 12_358 (40.53%), defined 18_130 (59.47%)
  // null: 7_968 (43.95%)
  header_media_uri: z.string().nullable().optional(),
  // undefined: 12_685 (41.61%), defined 17_803 (58.39%)
  // null: 15_854 (89.05%)
  header_asset_id: common.objectId.nullable().optional(),
  // undefined: 12_358 (40.53%), defined 18_130 (59.47%)
  // null: 7_873 (43.43%)
  header_media_type: whatsAppMediaTypeSchema,
});
